// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__0uvC2","sliderContainer":"Slider_sliderContainer__pPf+I"};